module.exports = __webpack_public_path__ + "wood.fb417622f45fb557b377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wood.jpg
// module id = ./src/assets/images/wood.jpg
// module chunks = main styles